import bem from 'utils/bem';

export const block = bem('hl-popover');
export const popoverRadioGroupBlock = bem('popover-radio-group');
